import config from "@/config";
import http from "@/utils/request";

export default {
	give: {
		list: {
			url: `${config.API_URL}/market_activity/list`,
			name: "获取满赠活动列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/market_activity/store`,
			name: "新增编辑满赠活动",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/market_activity/detail`,
			name: "获取满赠活动详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/market_activity/del`,
			name: "删除满赠活动",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
};
